namespace RedBullMOBILE360.CustomerCare {
    export interface ManualResumeFraudCasesRow {
        Msisdn?: string;
        IdNumber?: string;
    }

    export namespace ManualResumeFraudCasesRow {
        export const idProperty = 'Msisdn';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'CustomerCare.ManualResumeFraudCases';
        export const deletePermission = 'CustomerCare:BulkResumeFraudCases';
        export const insertPermission = 'CustomerCare:BulkResumeFraudCases';
        export const readPermission = 'CustomerCare:BulkResumeFraudCases';
        export const updatePermission = 'CustomerCare:BulkResumeFraudCases';

        export declare const enum Fields {
            Msisdn = "Msisdn",
            IdNumber = "IdNumber"
        }
    }
}
